import * as React from "react";
import { motion } from "framer-motion";
import TermsSection from "./TermsSection";

const PrivacyPolicy = () => {
    return (
        <main className="flex flex-col items-center px-5 pt-60 pb-26 w-full bg-white min-h-[screen]">
            <article className="w-full max-w-[845px]">
                <motion.h1 className="mb-16 text-5xl font-bold text-center text-black max-md:text-4xl max-sm:text-3xl"
                    initial={{ opacity: 0, y: 50 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.5, ease: "easeOut" }}
                    viewport={{ once: true }}
                >
                    Privacy Policy
                </motion.h1>

                <motion.div className="flex flex-col gap-11"
                    initial={{ opacity: 0, y: 50 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ duration: 1, ease: "easeOut" }}
                    viewport={{ once: true }}
                >
                    <section className="flex flex-col gap-6">
                        <h2 className="text-lg font-bold text-black">
                            I Excel Management & Services Privacy Policy
                        </h2>

                        <TermsSection
                            number="1"
                            title="Introduction"
                            content="This Privacy Policy describes how I Excel Management & Services collects, uses, and protects the personal information of its students, parents, and other users."
                        />
                    </section>

                    <TermsSection
                        number="2"
                        title="Information We Collect"
                        content="We may collect personal information such as name, contact details, date of birth, and educational background. We also collect information about your program participation, including attendance and performance."
                    />

                    <TermsSection
                        number="3"
                        title="How We Use Your Information"
                        content="We use your information to administer your program, communicate with you about your enrollment, and provide you with the best possible learning experience. We may also use your information for internal analysis and improvement of our services."
                    />

                    <TermsSection
                        number="4"
                        title="Information Sharing"
                        content="We do not share your personal information with third parties except as required by law or with your consent."
                    />

                    <TermsSection
                        number="5"
                        title="Security"
                        content="We implement reasonable security measures to protect your personal information from unauthorized access, use, or disclosure."
                    />

                    <TermsSection
                        number="6"
                        title="Your Rights"
                        content="You have the right to access, correct, and delete your personal information. Please contact us at info@iexcel.my to exercise these rights."
                    />

                    <TermsSection
                        number="7"
                        title="Changes to this Policy"
                        content="We may update this Privacy Policy from time to time. We will post any changes on this page."
                    />

                    <TermsSection
                        number="8"
                        title="Contact Us"
                        content="For any questions or concerns regarding this Privacy Policy, please contact us at info@iexcel.my or +6 (016) 293-2691."
                    />
                </motion.div>
            </article>
        </main>
    );
}

export default PrivacyPolicy;
